/** C1 — «مُستردّون» و«معدل الاسترداد» في مركز العملاء الموحّد: customers_by_branch_rfm نفسها (recovery) + المقارنتان. */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useCustomerFilter } from "./CustomerFilterContext";
import CustomerListModal from "../components/CustomerListModal";

const TEAL = "#065F46";
const MUTE = "#78716C";
const CMP_LABEL = { length: "الفترة السابقة", month: "نفس الفترة من الشهر الماضي" };
const n1 = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 1 });

function Delta({ cur, prev, points, testId }) {
  const d = Number(cur || 0) - Number(prev || 0);
  if (!points) {
    const p = prev ? Math.round((d / prev) * 100) : null;
    if (p === null) return null;
    return <span data-testid={testId} style={{ color: p >= 0 ? "#0F766E" : "#B91C1C" }}> ({p >= 0 ? "▲" : "▼"} {Math.abs(p)}٪)</span>;
  }
  return <span data-testid={testId} style={{ color: d >= 0 ? "#0F766E" : "#B91C1C" }}> ({d >= 0 ? "▲ +" : "▼ −"}{n1(Math.abs(d))} نقطة)</span>;
}

export default function RecoveryRateCard() {
  const shared = useCustomerFilter();
  const from = shared?.from || undefined;
  const to = shared?.to || undefined;
  const branchId = shared?.branchId || "";
  const [data, setData] = useState(null);
  const [cmp, setCmp] = useState(null);
  const [modal, setModal] = useState(null);
  useEffect(() => {
    api.get("/pos/customers-by-branch-rfm", { params: { from, to } }).then((r) => setData(r.data)).catch(() => setData(null));
    api.get("/pos/customers-by-branch-rfm/compare", { params: { from, to } }).then((r) => setCmp(r.data)).catch(() => setCmp(null));
  }, [from, to]);
  if (!data) return null;
  const pick = (src) => (branchId ? (src?.branches || {})[branchId] : src?.recovery);
  const cur = branchId ? (data.branches || []).find((b) => b.branch_id === branchId) || {} : data.recovery || {};
  return (
    <div data-testid="recovery-rate-card" style={{ border: "1px solid rgba(6,95,70,0.20)", borderRadius: 14, padding: "12px 14px", background: "#fff", margin: "10px 0" }}>
      <div style={{ fontWeight: 800, color: TEAL }}>استرداد العملاء المفقودين</div>
      <div style={{ fontSize: 10, color: MUTE, marginBottom: 6 }}>{data.recovery?.definition}</div>
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 10, color: MUTE }}>مُستردّون</div>
          <button type="button" data-testid="recovery-recovered-open" style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontSize: 22, fontWeight: 900, color: TEAL, fontFamily: "monospace" }}
            onClick={() => setModal({ from: data.from, to: data.to, title: "مُستردّون — الفترة الحالية" })}>{n1(cur.recovered)}</button>
        </div>
        <div>
          <div style={{ fontSize: 10, color: MUTE }}>معدل الاسترداد</div>
          <div data-testid="recovery-rate-value" style={{ fontSize: 22, fontWeight: 900, color: TEAL, fontFamily: "monospace" }}>{n1(cur.recovery_rate)}%</div>
          <div style={{ fontSize: 10, color: MUTE }}>من {n1(cur.lost_at_start)} مفقوداً عند بداية الفترة</div>
        </div>
      </div>
      {cmp && ["length", "month"].map((u) => {
        const c = cmp[u];
        const p = pick(c) || {};
        return (
          <div key={u} data-testid={`recovery-cmp-${u}`} style={{ fontSize: 10, color: MUTE, marginTop: 4 }}>
            {CMP_LABEL[u]}:{" "}
            {c?.has_data ? <>
              <button type="button" data-testid={`recovery-cmp-${u}-open`} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontWeight: 800, color: TEAL, textDecoration: "underline dotted" }}
                onClick={() => setModal({ from: data.from, to: data.to, winStart: c.win_start, winEnd: c.win_end, title: `مُستردّون — ${c.mode}` })}>{n1(p.recovered)}</button>
              <Delta cur={cur.recovered} prev={p.recovered} testId={`recovery-cmp-${u}-delta`} />
              {" · "}{n1(p.recovery_rate)}%<Delta cur={cur.recovery_rate} prev={p.recovery_rate} points testId={`recovery-cmp-${u}-rate-delta`} />
            </> : "لا بيانات للفترة"}
          </div>
        );
      })}
      {modal && (
        <CustomerListModal kind="recovered" branchId={branchId || null} dateFrom={modal.from} dateTo={modal.to}
          winStart={modal.winStart} winEnd={modal.winEnd} card={branchId ? "branch" : undefined} title={modal.title}
          onClose={() => setModal(null)} />
      )}
    </div>
  );
}
